import React from "react";
import { useNavigate } from "react-router-dom";

export default function CtaSection({ heading, text, cta, launchMode = false }) {
  const navigate = useNavigate();

  const isDisabled = launchMode || Boolean(cta?.disabled);

  const handleClick = () => {
    if (isDisabled) return;
    if (cta?.href) navigate(cta.href);
  };

  return (
    <section
      style={{
        padding: "18px 20px",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          maxWidth: 720,
          width: "100%",
          textAlign: "center",
        }}
      >
        {heading && (
          <h3 style={{ fontSize: 20, fontWeight: 600, marginBottom: 12 }}>
            {heading}
          </h3>
        )}

        {text && (
          <p
            style={{
              fontSize: 15,
              lineHeight: 1.7,
              color: "#e5e7eb",
              marginBottom: 16,
            }}
          >
            {text}
          </p>
        )}

        {cta?.label && (
          <button
            type="button"
            onClick={handleClick}
            disabled={isDisabled}
            style={{
              padding: "12px 26px",
              borderRadius: 999,

              display: "inline-flex",
              alignItems: "center",
              gap: 8,

              background: isDisabled ? "rgba(245,158,11,0.16)" : "#f59e0b",

              color: isDisabled ? "rgba(245,158,11,0.95)" : "#020617",

              fontSize: 14,
              fontWeight: 600,

              border: isDisabled ? "1px solid rgba(245,158,11,0.35)" : "none",

              cursor: isDisabled ? "default" : "pointer",

              opacity: isDisabled ? 0.88 : 1,
              transition: "0.25s ease",

              boxShadow: isDisabled
                ? "none"
                : "0 14px 40px rgba(245,158,11,0.18)",
            }}
            onMouseEnter={(e) => {
              if (isDisabled) return;
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0px)";
            }}
          >
            {/* 🔒 Lock icon when disabled */}
            {isDisabled && (
              <span
                aria-hidden="true"
                style={{
                  fontSize: 14,
                  lineHeight: 1,
                  opacity: 0.95,
                }}
              >
                🔒
              </span>
            )}

            {cta.label}

            {/* Badge */}
            {isDisabled && (
              <span
                style={{
                  marginLeft: 6,
                  fontSize: 11,
                  fontWeight: 700,
                  letterSpacing: "0.02em",
                  padding: "4px 10px",
                  borderRadius: 999,
                  background: "rgba(2,6,23,0.35)",
                  border: "1px solid rgba(245,158,11,0.25)",
                  color: "rgba(245,158,11,0.9)",
                }}
              >
                Limited Preview
              </span>
            )}
          </button>
        )}

        {isDisabled && (
          <p
            style={{
              marginTop: 12,
              fontSize: 12.5,
              color: "rgba(203,213,225,0.75)",
              lineHeight: 1.6,
            }}
          >
            We’re preparing the first public launch. Stay tuned.
          </p>
        )}
      </div>
    </section>
  );
}
